import { ORDER_DESIGN_REVIEW_TIMEFRAME_DAYS } from "./orderDesigns.constants";
import type { OrderDesign } from "./orderDesigns.types";

/**
 * Returns the remaining time in milliseconds for an opened order design to be reviewed.
 * If the order design cannot be reviewed it returns -1.
 *
 * The review period is assumed to be 48 hours from the time the order design was opened.
 *
 * @param param0
 * @returns
 */
export const getRemainingTimeToReview = ({
  orderDesign,
  currentDate = new Date(),
}: {
  orderDesign: Pick<OrderDesign, "history" | "status" | "updatedAt">;
  currentDate?: Date;
}): number => {
  if (orderDesign.status !== "OPENED") {
    return -1;
  }

  const sortedHistory = [...orderDesign.history].sort(
    (a, b) => new Date(b.changedAt).getTime() - new Date(a.changedAt).getTime()
  );

  const openedRecord = sortedHistory.find(record => record.status === "OPENED");

  const reviewDeadline = new Date(
    openedRecord?.changedAt ?? orderDesign.updatedAt
  );
  reviewDeadline.setDate(
    reviewDeadline.getDate() + ORDER_DESIGN_REVIEW_TIMEFRAME_DAYS
  );

  const remainingTime = reviewDeadline.getTime() - currentDate.getTime();

  return remainingTime >= 0 ? remainingTime : -1;
};
